
























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import _ from "lodash";
import EventBus from "front-component/EventBus";

@Component({})
export default class SelectSearch extends Vue {
    @Prop({ default: "" }) public value!: string;
    @Prop() public filterName!: string;
    @Prop() public options!: object[];
    @Prop() public classes!: string;

    private filter: string = "";

    public mounted(): void {
        this.filter = this.value;
    }

    @Watch("filter") public onFilterChange(value: string): void {
        EventBus.$emit("update-filter", _.set({}, this.filterName, value));
    }
}
